import { render, staticRenderFns } from "./WishListLogin.vue?vue&type=template&id=0f805d9f&scoped=true"
import script from "./WishListLogin.vue?vue&type=script&lang=js"
export * from "./WishListLogin.vue?vue&type=script&lang=js"
import style0 from "./WishListLogin.vue?vue&type=style&index=0&id=0f805d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f805d9f",
  null
  
)

export default component.exports